module.exports = __webpack_public_path__ + "static/media/Dirt_record.d9790976.gif";